import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import clsx from "clsx";
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import type { Page } from "../../models/page";
import {
  buildQueryParams,
  getSignupParams,
  SignupParamItem,
  parseQueryParams,
  QueryParams,
} from "../../models/signupParam";
import Filter from "./Filter";
import Table from "./Table";

const useStyles = makeStyles(
  (theme: import("@material-ui/core/styles").Theme) => ({
    root: {
      width: "100%",
      maxWidth: 1680,
      margin: "0 auto",
      padding: theme.spacing(3),
    },
    title: {
      marginBottom: theme.spacing(2),
    },
    filter: {
      marginBottom: theme.spacing(3),
    },
    pageInfo: {
      marginTop: theme.spacing(3),
      textAlign: "center",
    },
    buttonContainer: {
      display: "flex",
      marginTop: theme.spacing(3),
    },
    hasPrevNext: {
      justifyContent: "space-between",
    },
    hasNext: {
      justifyContent: "flex-end",
    },
  })
);

export default function RegistrationAnalysis() {
  const classes = useStyles();

  const { pathname, search } = useLocation();

  const [signupParams, setSignupParams] = useState<SignupParamItem[]>([]);
  const [page, setPage] = useState<Page>({});
  const [params, setParams] = useState<QueryParams>({});
  const [totalCount, setTotalCount] = useState<number>(0);
  const [loading, setLoading] = useState(true);

  const load = (params: QueryParams) => {
    setLoading(true);
    getSignupParams(params)
      .then((res) => {
        setSignupParams(res.signupParams);
        setPage(res.page);
        setTotalCount(res.totalCount);
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    const params = parseQueryParams(search);
    setParams(params);
    load(params);
  }, [search]);

  const history = useHistory();
  const handleQueryParams = (params: QueryParams) => {
    const p = buildQueryParams(params);
    history.push(`${pathname}?${p.toString()}`);
  };

  const handleNext = () => {
    if (page?.next) {
      handleQueryParams({ ...params, page: page.next });
    }
  };
  const handlePrev = () => {
    if (page?.prev) {
      handleQueryParams({ ...params, page: page.prev });
    }
  };

  const handleFilter = (params: QueryParams) => {
    handleQueryParams(params);
  };

  return (
    <div className={classes.root}>
      <Typography className={classes.title} component="h1" variant="h3">
        登録分析
      </Typography>
      <Filter
        className={classes.filter}
        params={params}
        onFilter={handleFilter}
      />
      {loading ? (
        <Typography align="center" color="textSecondary">
          読み込み中...
        </Typography>
      ) : (
        <Table signupParams={signupParams} />
      )}
      <Typography
        className={classes.pageInfo}
        color="textSecondary"
        variant="body2"
      >
        全{totalCount}件 / 100件ずつ表示 / {params.page || 1}ページ目
      </Typography>
      {(page.prev || page.next) && (
        <div
          className={clsx(classes.buttonContainer, {
            [classes.hasPrevNext]: page.prev && page.next,
            [classes.hasNext]: !page.prev && page.next,
          })}
        >
          {page.prev && (
            <Button color="default" variant="contained" onClick={handlePrev}>
              前へ
            </Button>
          )}
          {page.next && (
            <Button color="default" variant="contained" onClick={handleNext}>
              次へ
            </Button>
          )}
        </div>
      )}
    </div>
  );
}
